import type { EncircledIconVariant } from "components/EncircledIcon/EncircledIcon.styled";

export enum GroupEnrollmentOutcomeType {
  JoinSuccessful = 1,
  NotAllowedToJoin = 2,
  NotExistingGroup = 3,
}

export interface GroupEnrollmentOutcomeProps {
  groupName?: string;
  outcomeType: GroupEnrollmentOutcomeType;
}

export interface GroupEnrollmentOutcomeParams {
  dataCy?: string;
  title: string;
  description?: string | React.ReactNode;
  iconName: string;
  iconVariant: EncircledIconVariant;
}
